// extracted by mini-css-extract-plugin
export default {"header":"c1Pwe","layout":"t2dNb","tablet":"EkjJT","desktop":"qEHYb"};